module.exports = __webpack_public_path__ + "assets/icons/table-sorted-asc.svg";